import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class DrivingLicenseAvailability extends _BaseUserProfile {
  component = 'YesNoSelection';
  props = {
    title: 'Do You Have a Valid Driver’s License?',
    errorMessage: 'Please Answer on Question',
    additionalFormInModal: false,
    modalTitle: 'Add Information About Your Driving License',
    additionalFormComponent: 'DrivingLicenseForm',
  };
  skipConditionsExists = true;
  skipConditions = {
    value: false,
    stepToGo: 8,
  };
}
